import { useEffect, useRef, useState } from 'react'

interface ModalProps {
  title: string
  onClose: () => void
  children: React.ReactNode
  wide?: boolean
}

export function Modal({ title, onClose, children, wide }: ModalProps) {
  const overlayRef = useRef<HTMLDivElement>(null)
  const [interactive, setInteractive] = useState(false)

  useEffect(() => {
    // Delay overlay pointer-events by one frame so the triggering click
    // completes before the overlay can intercept events.
    const id = requestAnimationFrame(() => setInteractive(true))
    return () => cancelAnimationFrame(id)
  }, [])

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', handleKey)
    return () => window.removeEventListener('keydown', handleKey)
  }, [onClose])

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === overlayRef.current) onClose()
  }

  return (
    <div
      className="modal-overlay"
      ref={overlayRef}
      onClick={handleOverlayClick}
      style={interactive ? undefined : { pointerEvents: 'none' }}
    >
      <div className="modal" style={wide ? { width: 720 } : undefined}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="dismiss" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  )
}
